import { struct } from 'io-ts/lib/Decoder';

import { DimensionLine } from './scale/DimensionLine';

/**
 * A floorplan level's overall external size.
 *
 * Both directions use this one shape: Brain Engine measures the pair and sends
 * it on the page state, and the External Dimensions step posts the same pair
 * back with the estimator's corrected `calculatedLength`.
 */
export const ExternalDimensions = struct({
	xDimension: DimensionLine,
	yDimension: DimensionLine,
});
